import { httpClient } from '../lib/http-client';
import { TicketFavorito, FavoritoToggleResponse, FavoritoStatusResponse } from '../types';

/**
 * Service para gerenciamento de favoritos
 */
export class FavoritosService {
  static async getFavoritos(): Promise<TicketFavorito[]> {
    return httpClient.get<TicketFavorito[]>('/api/favoritos');
  }

  static async getFavorito(id: number): Promise<TicketFavorito> {
    return httpClient.get<TicketFavorito>(`/api/favoritos/${id}`);
  }

  static async adicionarFavorito(ticketId: number): Promise<TicketFavorito> {
    return httpClient.post<TicketFavorito>('/api/favoritos', { ticket_id: ticketId });
  }

  static async removerFavorito(favoritoId: number): Promise<{ success: boolean }> {
    return httpClient.delete<{ success: boolean }>(`/api/favoritos/${favoritoId}`);
  }

  static async toggleFavorito(ticketId: number): Promise<FavoritoToggleResponse> {
    return httpClient.post<FavoritoToggleResponse>(`/api/tickets/${ticketId}/favorito/toggle`);
  }

  static async verificarFavorito(ticketId: number): Promise<FavoritoStatusResponse> {
    return httpClient.get<FavoritoStatusResponse>(`/api/tickets/${ticketId}/favorito`);
  }
}

